module.exports = __webpack_public_path__ + "img/babymilk.9edb42f9.png";